(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shpflt-announcement-banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const banners = document.querySelectorAll('.shpflt-announcement-banner[data-section-id]');
    
    banners.forEach(function(banner) {
      const sectionId = banner.dataset.sectionId;
      const isStatic = banner.dataset.isStatic === 'true';
      const scrollSpeed = banner.dataset.scrollSpeed || '20s';
      const hideOnScroll = banner.dataset.hideOnScroll === 'true';
      const closeButton = banner.querySelector('[data-close-banner]');
      const storageKey = 'shpflt-announcement-banner-closed-' + sectionId;

      // Check if banner was previously closed
      if (localStorage.getItem(storageKey) === 'true') {
        banner.setAttribute('data-closed', 'true');
        document.documentElement.style.setProperty('--announcement-height', '0px');
        return;
      }

      // Set announcement height CSS variable
      function setAnnouncementHeight() {
        if (banner.hasAttribute('data-closed') || banner.hasAttribute('data-closing')) {
          document.documentElement.style.setProperty('--announcement-height', '0px');
        } else if (banner.classList.contains('scrolled-down')) {
          document.documentElement.style.setProperty('--announcement-height', '0px');
        } else {
          const height = banner.offsetHeight;
          document.documentElement.style.setProperty('--announcement-height', height + 'px');
        }
      }

      // Handle scroll hide/show functionality
      let lastScrollTop = 0;
      let scrollThreshold = 50;
      
      if (hideOnScroll) {
        function handleScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          
          if (scrollTop > scrollThreshold) {
            if (scrollTop > lastScrollTop) {
              // Scrolling down
              banner.classList.add('scrolled-down');
            } else {
              // Scrolling up
              banner.classList.remove('scrolled-down');
            }
          } else {
            // Near top of page
            banner.classList.remove('scrolled-down');
          }
          
          lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
          setAnnouncementHeight(); // Update height when scrolling
        }
        
        window.addEventListener('scroll', handleScroll, { passive: true });
        handleScroll(); // Initial check
      }

      // Set scroll speed for marquee
      if (!isStatic) {
        const marqueeContent = banner.querySelector('.shpflt-announcement-banner__marquee-content');
        if (marqueeContent) {
          marqueeContent.style.setProperty('--scroll-speed', scrollSpeed);
        }
      }

      // Set initial height
      setAnnouncementHeight();
      window.addEventListener('resize', setAnnouncementHeight);

      // Close button functionality
      if (closeButton) {
        closeButton.addEventListener('click', function() {
          const section = banner.closest('.shpflt-announcement-banner-section');
          
          // Start closing animation
          banner.setAttribute('data-closing', 'true');
          
          // Update height during animation
          setTimeout(function() {
            setAnnouncementHeight();
          }, 50);
          
          // Complete the close after animation
          setTimeout(function() {
            banner.setAttribute('data-closed', 'true');
            if (section) {
              section.classList.add('announcement-closed');
            }
            setAnnouncementHeight();
            localStorage.setItem(storageKey, 'true');
          }, 400);
        });
      }
    });

    // Theme editor integration
    document.addEventListener('shopify:section:load', function(event) {
      const sectionId = event.detail.sectionId;
      const reloadedBanner = document.querySelector('.shpflt-announcement-banner[data-section-id="' + sectionId + '"]');
      
      if (reloadedBanner) {
        const reloadedIsStatic = reloadedBanner.dataset.isStatic === 'true';
        const reloadedScrollSpeed = reloadedBanner.dataset.scrollSpeed || '20s';
        const reloadedHideOnScroll = reloadedBanner.dataset.hideOnScroll === 'true';
        
        if (!reloadedIsStatic) {
          const reloadedMarqueeContent = reloadedBanner.querySelector('.shpflt-announcement-banner__marquee-content');
          if (reloadedMarqueeContent) {
            reloadedMarqueeContent.style.setProperty('--scroll-speed', reloadedScrollSpeed);
          }
        }

        // Set announcement height for reloaded banner
        function setReloadedAnnouncementHeight() {
          if (reloadedBanner.hasAttribute('data-closed') || reloadedBanner.hasAttribute('data-closing')) {
            document.documentElement.style.setProperty('--announcement-height', '0px');
          } else if (reloadedBanner.classList.contains('scrolled-down')) {
            document.documentElement.style.setProperty('--announcement-height', '0px');
          } else {
            const height = reloadedBanner.offsetHeight;
            document.documentElement.style.setProperty('--announcement-height', height + 'px');
          }
        }
        setReloadedAnnouncementHeight();
        window.addEventListener('resize', setReloadedAnnouncementHeight);

        // Handle scroll hide/show for reloaded banner
        if (reloadedHideOnScroll) {
          let reloadedLastScrollTop = 0;
          const reloadedScrollThreshold = 50;
          
          function handleReloadedScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            
            if (scrollTop > reloadedScrollThreshold) {
              if (scrollTop > reloadedLastScrollTop) {
                reloadedBanner.classList.add('scrolled-down');
              } else {
                reloadedBanner.classList.remove('scrolled-down');
              }
            } else {
              reloadedBanner.classList.remove('scrolled-down');
            }
            
            reloadedLastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
          }
          
          window.addEventListener('scroll', handleReloadedScroll, { passive: true });
          handleReloadedScroll();
        }

        const reloadedCloseButton = reloadedBanner.querySelector('[data-close-banner]');
        if (reloadedCloseButton) {
          const storageKey = 'shpflt-announcement-banner-closed-' + sectionId;
          reloadedCloseButton.addEventListener('click', function() {
            const section = reloadedBanner.closest('.shpflt-announcement-banner-section');
            
            // Start closing animation
            reloadedBanner.setAttribute('data-closing', 'true');
            
            // Update height during animation
            setTimeout(function() {
              setReloadedAnnouncementHeight();
            }, 50);
            
            // Complete the close after animation
            setTimeout(function() {
              reloadedBanner.setAttribute('data-closed', 'true');
              if (section) {
                section.classList.add('announcement-closed');
              }
              setReloadedAnnouncementHeight();
              localStorage.setItem(storageKey, 'true');
            }, 400);
          });
        }
      }
    });

    document.addEventListener('shopify:section:unload', function(event) {
      // Clean up if needed
    });

    document.addEventListener('shopify:section:select', function(event) {
      const sectionId = event.detail.sectionId;
      const selectedBanner = document.querySelector('.shpflt-announcement-banner[data-section-id="' + sectionId + '"]');
      if (selectedBanner) {
        selectedBanner.style.outline = '2px solid rgba(var(--color-link-rgb), 0.5)';
        selectedBanner.style.outlineOffset = '2px';
      }
    });

    document.addEventListener('shopify:section:deselect', function(event) {
      const sectionId = event.detail.sectionId;
      const deselectedBanner = document.querySelector('.shpflt-announcement-banner[data-section-id="' + sectionId + '"]');
      if (deselectedBanner) {
        deselectedBanner.style.outline = '';
        deselectedBanner.style.outlineOffset = '';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
